import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import AccountLogo from './account-logo/account-logo.jsx';
import GroupLogo from './group-logo/group-logo.jsx';
import NavigationIcon from './navigation-icon.jsx';
import repkaAvatar from './repka-384.jpg';

import styles from './header.module.css';

const DEFAULT_TOPIC_TITLE = 'Репка / Repka-Pi';

const navigationItems = [
  {
    key: 'shop',
    label: 'navigation_shop',
    href: '/',
  },
  {
    key: 'blog',
    label: 'navigation_blog',
    href: '/blog',
  },
  {
    key: 'docs',
    label: 'navigation_docs',
    href: '/docs',
  },
  {
    key: 'forum',
    label: 'navigation_forum',
    href: '/forum',
  },
  {
    key: 'vk',
    label: 'VK',
    href: 'https://vk.com/npo_rbs',
    external: true,
  },
  {
    key: 'channel',
    label: 'navigation_channel',
    href: 'https://t.me/repka_pi3',
    external: true,
  },
  {
    key: 'group',
    label: 'navigation_group',
    href: 'https://t.me/RepkaPitalk',
    external: true,
  },
];

const messages = defineMessages({
  navigation: {
    id: 'navigation',
    defaultMessage: 'Navigation',
    description: 'Page navigation aria label',
  },
  subscriber_count: {
    id: 'subscriber_count',
    defaultMessage:
      '{count, plural, ' +
      'one {{count, number} subscriber} ' +
      'two {{count, number} subscribers} ' +
      'three {{count, number} subscribers} ' +
      'few {{count, number} subscribers} ' +
      'many {{count, number} subscribers} ' +
      'other {{count, number} subscribers}}',
    description: 'Count of channel subscribers',
  },
  member_count: {
    id: 'member_count',
    defaultMessage:
      '{count, plural, ' +
      'one {{count, number} member} ' +
      'two {{count, number} members} ' +
      'three {{count, number} members} ' +
      'few {{count, number} members} ' +
      'many {{count, number} members} ' +
      'other {{count, number} members}}',
    description: 'Count of group topic members',
  },
  menu_item_info: {
    id: 'menu_item_info',
    defaultMessage: 'Info',
    description: 'Show extended topic information',
  },
  navigation_shop: {
    id: 'navigation_shop',
    defaultMessage: 'Shop',
    description: 'Navigation link to the shop',
  },
  navigation_blog: {
    id: 'navigation_blog',
    defaultMessage: 'Blog',
    description: 'Navigation link to the blog',
  },
  navigation_docs: {
    id: 'navigation_docs',
    defaultMessage: 'Docs',
    description: 'Navigation link to the documentation',
  },
  navigation_forum: {
    id: 'navigation_forum',
    defaultMessage: 'Forum',
    description: 'Navigation link to the forum',
  },
  navigation_channel: {
    id: 'navigation_channel',
    defaultMessage: 'Channel',
    description: 'Navigation link to the Telegram channel',
  },
  navigation_group: {
    id: 'navigation_group',
    defaultMessage: 'Group',
    description: 'Navigation link to the Telegram group',
  },
});

class Header extends React.PureComponent {
  renderNavigationItem(item, mobile, onSelected) {
    if (item.href) {
      return (
        <a
          key={item.key}
          className={mobile ? styles.menuItem : styles.navItem}
          href={item.href}
          target={item.external ? '_blank' : undefined}
          rel={item.external ? 'noopener' : undefined}
          onClick={mobile ? onSelected : undefined}
        >
          <NavigationIcon name={item.key} className={styles.linkIcon} />
          <span>{item.label}</span>
        </a>
      );
    }

    const className = item.active ? `${styles.navItem} ${styles.active}` : styles.navItem;
    return (
      <button
        key={item.key}
        type="button"
        className={mobile ? styles.menuItem : className}
        disabled={item.disabled}
        onClick={e => {
          if (item.onSelect) {
            item.onSelect(e);
          }
          if (mobile && onSelected) {
            onSelected();
          }
        }}
      >
        <NavigationIcon name={item.key} className={styles.linkIcon} />
        <span>{item.label}</span>
      </button>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const topic = this.props.topic;
    // Для начального чата GroupLogo всегда использует локальные название и аватарку Репки.
    const topicTitle = DEFAULT_TOPIC_TITLE;
    const topicMembers = topic ? topic.subcnt : 0;
    const topicSubtitle = topicMembers
      ? formatMessage(topic.isChannelType() ? messages.subscriber_count : messages.member_count, {
          count: topicMembers,
        })
      : '';
    const user = this.props.user || {};
    const isAdmin = this.props.acs && this.props.acs.isAdmin();
    const authorizeURL = this.props.authorizeURL || (url => url);
    const localizedNavigationItems = navigationItems.map(item => ({
      ...item,
      label: messages[item.label] ? formatMessage(messages[item.label]) : item.label,
    }));

    return (
      <header className={styles.root}>
        <GroupLogo
          className={styles.groupLogo}
          isAdmin={isAdmin}
          loading={this.props.chatLoading}
          topic={{
            authorizeURL: authorizeURL,
            avatar: repkaAvatar,
            id: this.props.topicName,
            title: topicTitle,
            subtitle: topicSubtitle,
          }}
          infoLabel={formatMessage(messages.menu_item_info)}
          onInfo={this.props.onTopicInfo}
          navigationItems={localizedNavigationItems}
        />

        <nav className={styles.nav} aria-label={formatMessage(messages.navigation)}>
          {localizedNavigationItems.map(item => this.renderNavigationItem(item, false))}
        </nav>

        <AccountLogo user={user} loading={this.props.profileLoading} onUserSettings={this.props.onUserSettings} />
      </header>
    );
  }
}

export default injectIntl(Header);
